<template>
  <div>
    <div class="google-map" ref="googleMap"></div>
    <template v-if="Boolean(google) && Boolean(map)">
      <slot :google="google" :map="map"></slot>
    </template>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'
import { apiKey, mapConfig } from './googleMapConfig'

export default {
  name: 'googleMap',
  data () {
    return {
      google: null,
      map: null
    }
  },
  methods: {
    initMap () {
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(mapContainer, mapConfig)
      this.initMapClick()
    },
    initMapClick () {
      this.google.maps.event.addListener(this.map, 'click', () => {
        if (this.google.maps._openedWindows) {
          this.google.maps._openedWindows.close()
          this.google.maps._openedWindows = null
        }
      })
    },
    zoomMap (config) {
      const c = {
        ...mapConfig,
        ...config
      }
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(mapContainer, c)
    }
  },
  async mounted () {
    const googleLoader = new Loader({
      apiKey: apiKey
    })
    googleLoader
      .load()
      .then(() => {
        this.$nextTick(() => {
          this.google = { ...window.google }
          this.initMap()
        })
      })
  }
}
</script>

<style scoped lang="scss">
.google-map {
  width: 100%;
  min-height: 350px;
  border-radius: 5px;
  overflow: hidden;
}
</style>
